import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Monitor, GraduationCap } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-3 pb-4 px-3 relative overflow-hidden" data-id="element-127">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-128">
        <div className="inline-block bg-brand-accent text-white font-bold px-3 py-1 rounded-full mb-2 text-[10px] md:text-xs tracking-wider shadow-md" data-id="element-129">
          ⚙️ KIT PROFE™
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-3 leading-tight text-shadow-lg" data-id="element-130">
          El sistema N°1 para docentes de programación en escuelas técnicas de
          Argentina
        </h1>

        <h2 className="text-base md:text-2xl font-black mb-3 text-brand-accent neon-glow" data-id="element-131">
          Todo tu año de Programación Técnica. Listo. Desde hoy.
        </h2>

        <a href="#compra" onClick={scrollToCompra} className="w-full max-w-xs md:max-w-lg mx-auto mb-3 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 block" data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/oBhprpiB8ZhZSSLzgE8fpj/mockupps_programacion_tecnica.png" alt="Kit Completo Programación Técnica Lista" className="w-full h-auto drop-shadow-2xl" data-id="element-133" />
        </a>

        <p className="text-xs md:text-base mb-3 font-bold text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-134">
          6 Tomos + 4 Bonos + Evaluaciones + Actividades + Planificaciones
          listos para usar en el laboratorio y el aula, sin buscar, sin armar,
          sin perder más domingos.
        </p>

        <div className="grid grid-cols-2 gap-1.5 md:flex md:items-center md:justify-center md:gap-3 mb-3 w-full max-w-sm md:max-w-none mx-auto" data-id="element-135">
          <div className="flex items-center justify-center bg-brand-accent/10 px-2 py-1.5 rounded-md border border-brand-accent/30 text-[10px] md:text-sm font-bold text-white" data-id="element-136">
            <FileText className="w-3 h-3 md:w-4 md:h-4 mr-1.5 text-brand-accent shrink-0" data-id="element-137" />
            <span data-id="element-138">📄 100% PDF</span>
          </div>
          <div className="flex items-center justify-center bg-brand-accent/10 px-2 py-1.5 rounded-md border border-brand-accent/30 text-[10px] md:text-sm font-bold text-white" data-id="element-139">
            <Zap className="w-3 h-3 md:w-4 md:h-4 mr-1.5 text-brand-accent shrink-0" data-id="element-140" />
            <span data-id="element-141">⚡ Acceso en 5 min</span>
          </div>
          <div className="flex items-center justify-center bg-brand-accent/10 px-2 py-1.5 rounded-md border border-brand-accent/30 text-[10px] md:text-sm font-bold text-white" data-id="element-142">
            <Monitor className="w-3 h-3 md:w-4 md:h-4 mr-1.5 text-brand-accent shrink-0" data-id="element-143" />
            <span data-id="element-144">🖥️ NAP/INET</span>
          </div>
          <div className="flex items-center justify-center bg-brand-accent/10 px-2 py-1.5 rounded-md border border-brand-accent/30 text-[10px] md:text-sm font-bold text-white" data-id="element-145">
            <GraduationCap className="w-3 h-3 md:w-4 md:h-4 mr-1.5 text-brand-accent shrink-0" data-id="element-146" />
            <span data-id="element-147">🇦🇷 Secundaria Técnica</span>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto mb-2" data-id="element-148">
          <Button className="text-base md:text-xl py-3 md:py-4" data-id="element-149">
            👉 QUIERO MI KIT AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-150">
          <div className="flex items-center" data-id="element-151">
            <ShieldCheck className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-152" />
            <span data-id="element-153">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-154">
            <Lock className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-155" />
            <span data-id="element-156">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-157">
            <CreditCard className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-158" />
            <span data-id="element-159">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}